import React from 'react';
import PrintIcon from '@mui/icons-material/Print';
import LzCModuleChildBase, { LzIModuleChildBase } from './ModuleChildBase';

export interface LzIReport extends LzIModuleChildBase {
    /**
     * Report component for the report.
     */
    reportComponent: React.ReactNode;
}

class LzCReport extends LzCModuleChildBase implements LzIReport {
    reportComponent: React.ReactNode;

    constructor(model?: LzIReport) {
        super(model);

        this.variation = 'Report';

        this.icon = model?.icon || <PrintIcon />;
        this.reportComponent = model?.reportComponent;
    }
}

export default LzCReport;
